export enum UnreadIndicatorSize {
  SMALL = 'small',
  MID = 'mid',
}

export enum UnreadIndicatorPosition {
  TOP_RIGHT = 'top-right',
  INLINE = 'inline',
}

export enum UnreadIndicatorColor {
  RED = 'red',
  BLUE = 'blue',
}
